const clamp = (element, options = {}) => {
    const opt = {
        clamp: options.clamp || 2,
    };
    const { style } = element;
    const clampValue = opt.clamp;
    style.overflow = 'hidden';
    style.textOverflow = 'ellipsis';
    style.webkitBoxOrient = 'vertical';
    style.display = '-webkit-box';
    style.webkitLineClamp = clampValue.toString();
};
export default clamp;
//# sourceMappingURL=clamp.js.map